
export default function AppGridItemPlaceholder({}) {

   
  return (
    <>      
      <div className="animate-pulse relative flex items-center px-3 py-3 space-x-3 rounded-md    
                                    hover:shadow-md bg-white border border-gray-200 text-gray-900 hover:text-crisp-700
                                    focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-crisp-500" >
        <div className="flex-shrink-0">
          <div className="p-1 border border-gray-200 rounded-md">
            <span className='inline-flex items-center justify-center bg-gray-100 h-10 w-10 rounded-md'>
              <span className="text-white capitalize">
              </span>
            </span>             
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p data-placeholder="" className="h-4 my-2 w-36 bg-gray-100"></p>              
        </div>
    
      </div>
    </>
  )
}
